import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path, Circle, Rect, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const CroquetIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="#001A19"
    title={t`Croquet`}
    {...props}
  >
    <G clipPath="url(#clip0_1093_2629)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        fill="none"
        d="M14.5 14V7.667a.333.333 0 0 0-.333-.334h-6a.333.333 0 0 0-.334.334V14"
      />
      <Circle cx={11.167} cy={14} r={1.333} fill="currentColor" />
      <Rect
        width={5.333}
        height={2.667}
        x={1.19}
        y={9.682}
        fill="currentColor"
        rx={0.333}
        transform="rotate(15 1.19 9.682)"
      />
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={1.5}
        d="M3.42 11.66 6.183 1.357"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1093_2629">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
